import { render, staticRenderFns } from "./imgs-overlay-list.vue?vue&type=template&id=34b58d14&scoped=true&"
import script from "./imgs-overlay-list.vue?vue&type=script&lang=js&"
export * from "./imgs-overlay-list.vue?vue&type=script&lang=js&"
import style0 from "./imgs-overlay-list.vue?vue&type=style&index=0&id=34b58d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b58d14",
  null
  
)

export default component.exports